// extracted by mini-css-extract-plugin
export default {"title":"FormTitle_title__oDSAa","inline":"FormTitle_inline__MWuuU"};